<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import {preview} from '../../../../store';
  import type {Media} from '../../../../types/media';
  import {writable} from 'svelte/store';
  import {getInstance} from '../../../../services/animation';
  import {tooltip} from '@/actions/tippy-action';
  import {doNotHidePopupOnNextClick, hidePopupOnNextClick} from '../../PopupBox/PopupBox.svelte';
  import Swal from 'sweetalert2';

  export let mediaItem: Media;
  export let masterPause = writable(false);

  let playState = false;
  let audio: HTMLAudioElement;
  function selectMediaItem(item: Media) {
    if (isActive) {
      preview.set({music: null});
      return;
    }
    preview.set({music: url, musicName: item.name});
    getInstance().setMetaMusic(url);
  }

  masterPause.subscribe(value => {
    if (value) {
      audio.pause();
      playState = false;
      masterPause.set(false);
    }
  });

  function toggleAudio() {
    if (!audio) return;
    if (audio.paused) {
      getInstance().pause();
      masterPause.set(true);
      audio.play();
      playState = true;
    } else {
      audio.pause();
      playState = false;
    }
  }
  let currentTime = writable(0);
  function timeUpdate() {
    currentTime.set(audio.currentTime);
  }
  onMount(() => {
    if (!audio) return;
    audio.addEventListener('timeupdate', timeUpdate);
  });

  onDestroy(() => {
    if (!audio) return;
    audio.removeEventListener('timeupdate', timeUpdate);
  });

  export let deleteMusic: (() => any) | undefined;

  function handleDelete() {
    setTimeout(() => {
      doNotHidePopupOnNextClick(true); // This will prevent the image popup sidebarr from closing when delete confirmation is clicked
    }, 250); // The timeout is required to debounce the click event which sometimes causes it to trigger a hide event
    // console.log('Delete image', item);
    Swal.fire({
      title: 'Are you sure you want to delete this music?',
      showCancelButton: true,
      didClose: () => {
        hidePopupOnNextClick(); // This reactivates the default functionality of the image popup sidebar on click (anywhere on the page it will close)
      }
    }).then(result => {
      if (result.isConfirmed && deleteMusic) {
        deleteMusic();
      }
    });
  }

  $: url = mediaItem.url ? mediaItem.url : mediaItem.file ? mediaItem.file.publicUrl : '';
  $: isActive = $preview.music && $preview.music == url;
  $: faClass = playState ? 'fa fa-circle-pause' : 'fa fa-circle-play';
  $: toggledClass = isActive ? 'font-bold' : '';
</script>

<div class={' flex w-full items-center gap-1 rounded-lg bg-white p-2 ' + toggledClass}>
  <div class="cursor-pointer rounded-xl px-2 text-xl" on:keypress={toggleAudio} on:click|stopPropagation={toggleAudio}>
    <i class={faClass} />
  </div>
  <div
    class="flex flex-grow cursor-pointer items-center px-2"
    on:keypress|stopPropagation|self={() => selectMediaItem(mediaItem)}
    on:click|stopPropagation|self={() => selectMediaItem(mediaItem)}
  >
    <div
      on:keypress|stopPropagation|self={() => selectMediaItem(mediaItem)}
      on:click|stopPropagation|self={() => selectMediaItem(mediaItem)}
      class="description-bar"
    >
      <span
        class="pointer-events-none block w-full truncate"
        on:keypress|stopPropagation|self={() => selectMediaItem(mediaItem)}
        on:click|stopPropagation|self={() => selectMediaItem(mediaItem)}>{mediaItem.name}</span
      >
      <input
        type="range"
        id="audio-progress"
        min="0"
        max="100"
        value={$currentTime}
        on:input|stopPropagation={e => (audio.currentTime = e.target.value)}
      />
      {#if url == ''}
        <span class="text-xs text-red-500">No audio file found for this record.</span>{/if}
    </div>
    <div class={isActive ? 'isActive ml-auto block flex-shrink-0 font-extrabold' : 'hidden'}>
      <i class="fa-sharp fa-solid fa-circle-check text-2xl text-primary" />
    </div>
  </div>
  {#if mediaItem?.file}
    <button class="mx-2 flex" use:tooltip={'Delete'} on:click={() => handleDelete()} on:keypress={() => handleDelete()}>
      <i class="fa fa-trash text-xl text-red-500" />
    </button>
  {/if}
  {#if url}
    <audio class="audioPreviewElement" bind:this={audio}>
      <source src={url} type="audio/mpeg" />
    </audio>
  {/if}
</div>

<style lang="postcss">
  .description-bar {
    width: 200px;
  }

  input {
    -webkit-appearance: none;
    background-size: 0% 100%;
    background-repeat: no-repeat;
    @apply h-2 w-full rounded bg-gray-300 bg-gradient-to-r from-primary to-primary-600;
  }

  input::-webkit-slider-thumb {
    -webkit-appearance: none;
    @apply h-3 w-3 rounded-full bg-secondary shadow-md;
  }

  input::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    @apply bg-transparent;
  }
</style>
